export default __webpack_public_path__ + "locales/nl/EmptyTrashDialog.json?hash=2d34428abb77bbee0cab554885276a79";